import {makeStyles, Theme} from "@material-ui/core";
import { codUploadReceiptStyles } from "./codUploadReceipt.shared.styles";

export const useStyles = makeStyles((theme: Theme) => ({
  ...codUploadReceiptStyles(theme)
}));
